import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { AxiosResponse } from "axios";

const api = new APIClient();

const path = "/hashtags";

const hashTagApi = {
  getHashTags(params: any = {}) : Promise<AxiosResponse<ResponseData<any>, any>>  {
    const url = `${path}`;
    return api.get(url, params)
  },

  getHashTag(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<any>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  postHashTag(dataForm: any) : Promise<AxiosResponse<ResponseData<any>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putHashTag(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<any>, any>>  {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },

  deleteHashTag(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default hashTagApi;
